import _ from 'lodash';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { isSuperAdmin, isChainAdmin } from 'shared/helpers/users';
import { useUser } from 'src/hooks/use-user';
import { openChatWidget } from 'shared/helpers/tools';
import useEnterprise from 'src/hooks/use-enterprise';

export function SidebarFooter(): JSX.Element {
  const location = useLocation();
  const { id: enterpriseId } = useEnterprise();
  const user = useUser();

  const isOnSuperAdminPage = _.includes(location.pathname, '/super/') || location.pathname === '/super';
  const isOnChainAdminPage = _.includes(location.pathname, '/enterprise/') || location.pathname === '/enterprise';

  const showBackToSuperAdmin = isSuperAdmin(user) && !isOnSuperAdminPage;
  const showBackToChainAdmin =
    (isSuperAdmin(user) || isChainAdmin(user)) && !isOnSuperAdminPage && !isOnChainAdminPage && enterpriseId;

  return (
    <Container>
      {(showBackToSuperAdmin || showBackToChainAdmin) && (
        <NavigationSection>
          {showBackToSuperAdmin && (
            <NavButton to='/super'>
              <ButtonIcon>←</ButtonIcon>
              Super Admin
            </NavButton>
          )}
          {showBackToChainAdmin && (
            <NavButton to={`/enterprise/${enterpriseId}`}>
              <ButtonIcon>←</ButtonIcon>
              All Locations
            </NavButton>
          )}
        </NavigationSection>
      )}

      <Section>
        <StyledLink onClick={openChatWidget}>Support</StyledLink>
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
        <StyledLink href='https://status.dutchie.com' target='_BLANK'>
          Status
        </StyledLink>
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
        <StyledLink onClick={() => void user.logout()}>Logout</StyledLink>
      </Section>
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 22px;
`;

const Section = styled.div`
  font-size: 12px;
  margin-top: 11px;
  text-align: center;
  span {
    color: #1a5c42;
  }
`;

const NavigationSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 20px;
  padding: 0 16px;
`;

const NavButton = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(241, 232, 214, 0.1);
  border: 1px solid rgba(241, 232, 214, 0.2);
  border-radius: 8px;
  color: #f1e8d6;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(241, 232, 214, 0.18);
    border-color: rgba(241, 232, 214, 0.35);
    color: #ffffff;
    text-decoration: none;
  }
`;

const ButtonIcon = styled.span`
  font-size: 14px;
  opacity: 0.8;
`;

const StyledLink = styled.a`
  color: #f1e8d6;
  cursor: pointer;

  &:hover {
    color: #ffffff;
    text-decoration: none;
  }
`;
